import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { GrowlServiceModule } from "@lantern/app/core";
import { ClipboardService } from "./clipboard.service";

@NgModule({
  imports: [CommonModule, GrowlServiceModule],
  providers: [ClipboardService]
})
export class ClipboardModule {}
